module.exports = __webpack_public_path__ + "static/img/skin_dummy.137fede.png";